module.exports = __webpack_public_path__ + "pc-top-assets/img/instagram-black.03383554.png";